<!-- eslint-disable vue/no-v-html -->
<template>
  <li
    v-if="canViewVerticalNavMenuGroup(item) && item.visible"
    class="nav-item has-sub"
    :class="{
      open: isOpen,
      disabled: item.disabled,
      'sidebar-group-active': isActive,
    }"
  >
    <b-link
      class="d-flex align-items-center"
      :class="{ 'childtitlestyle': Boolean(item.hasParent) }"
      @click="() => updateGroupOpen(!isOpen)"
    >
      <div
        v-if="item.customicon"
        v-html="item.customicon"
      />
      <feather-icon
        v-else
        :icon="item.icon || 'CircleIcon'"
      />
      <span class="menu-title text-truncate text-black font-weight-bold">{{ t(item.title) }}</span>
      <div
        v-if="isBadgeKomcards || isBadgeKomchatGroup || isBadgeKomchatBroadcast"
        class="badge-komform"
      >
        Baru
      </div>
      <b-badge
        v-if="item.tag"
        pill
        :variant="item.tagVariant || 'primary'"
        class="mr-1 ml-auto"
      >
        {{ item.tag }}
      </b-badge>
      <span
        v-if="item.title === 'Kendala' && followUp >= 1"
        class="mr-1 ml-auto p-[5px] rounded rounded-pill bg-[#F95031]"
      />
    </b-link>
    <b-collapse
      v-model="isOpen"
      class="menu-content"
      tag="ul"
    >
      <component
        :is="resolveNavItemComponent(child)"
        v-for="child in item.children"
        :key="child.header || child.title"
        ref="groupChild"
        :item="child"
      />
    </b-collapse>
  </li>
</template>

<script>
import { BLink, BBadge, BCollapse } from 'bootstrap-vue'
import { resolveVerticalNavMenuItemComponent as resolveNavItemComponent } from '@core/layouts/utils'
import { useUtils as useI18nUtils } from '@core/libs/i18n'
import { useUtils as useAclUtils } from '@core/libs/acl'
import VerticalNavMenuHeader from '../vertical-nav-menu-header'
import VerticalNavMenuLink from '../vertical-nav-menu-link/VerticalNavMenuLink.vue'

// Composition Function
import useVerticalNavMenuGroup from './useVerticalNavMenuGroup'
import mixinVerticalNavMenuGroup from './mixinVerticalNavMenuGroup'

export default {
  name: 'VerticalNavMenuGroup',
  components: {
    VerticalNavMenuHeader,
    VerticalNavMenuLink,
    BLink,
    BBadge,
    BCollapse,
  },
  mixins: [mixinVerticalNavMenuGroup],
  props: {
    item: {
      type: Object,
      required: true,
    },
  },
  computed: {
    isBadgeKomcards() {
      return ['Keuangan'].includes(this.item.title) && Boolean(this.komcardsBadge)
    },
    isBadgeKomchatBroadcast() {
      return ['Pelanggan'].includes(this.item.title) && Boolean(this.komchatBroadcastBadge)
    },
    isBadgeKomchatGroup() {
      return ['Pelanggan'].includes(this.item.title) && Boolean(this.komchatGroupBadge)
    },
  },
  watch: {
    $route: {
      handler(to, from) {
        if (to?.meta.resource !== from?.meta.resource && to.path === '/komcards') {
          if (this.komcardsBadge === true) {
            this.komcardsBadge = false
          }
        }
        if (to?.meta.resource !== from?.meta.resource && to.path === '/broadcast') {
          if (this.komchatBroadcastBadge === true) {
            this.komchatBroadcastBadge = false
          }
        }
        if (to?.meta.resource !== from?.meta.resource && to.path === '/grup-contact') {
          if (this.komchatGroupBadge === true) {
            this.komchatGroupBadge = false
          }
        }
        if (to?.meta.resource !== from?.meta.resource && this.item.title === 'Kendala') {
          this.followUp = sessionStorage.getItem('follow_up')
        }
      },
      immediate: true,
      deep: true,
    },
  },
  setup(props) {
    const {
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,
    } = useVerticalNavMenuGroup(props.item)

    const komcardsBadge = JSON.parse(localStorage.getItem('komcards-badge'))
    const komchatBroadcastBadge = JSON.parse(localStorage.getItem('broadcast-badge'))
    const komchatGroupBadge = JSON.parse(localStorage.getItem('group-contact-badge'))
    const followUp = sessionStorage.getItem('follow_up')

    const { t } = useI18nUtils()
    const { canViewVerticalNavMenuGroup } = useAclUtils()

    return {
      resolveNavItemComponent,
      isOpen,
      isActive,
      updateGroupOpen,
      updateIsActive,

      // ACL
      canViewVerticalNavMenuGroup,

      // i18n
      t,
      komcardsBadge,
      komchatBroadcastBadge,
      komchatGroupBadge,
      followUp,
    }
  },
}
</script>
<style>
.badge-komform {
  font-family: 'Poppins', sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 21px;
  letter-spacing: 0.5px;
  text-align: left;
  color: #F08519;
  margin-left: 10px;
  background: #FEF3E8;
  border: 1px solid #FAD9B8;
  border-radius: 8px;
  padding: 2px 6px;
}
</style>
